import { render, staticRenderFns } from "./DownloadAppCard.vue?vue&type=template&id=879e8516&scoped=true"
import script from "./DownloadAppCard.vue?vue&type=script&lang=js"
export * from "./DownloadAppCard.vue?vue&type=script&lang=js"
import style0 from "./DownloadAppCard.vue?vue&type=style&index=0&id=879e8516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879e8516",
  null
  
)

export default component.exports